import { useMemo } from "react";
import { useSelector } from "react-redux";
import { getShortOrderByNumber, getShopByNumber } from "../selectors";
import { getAddressDropdown } from "../selectors/dropdowns";
import { isAvalaraShop } from "../helpers/order";

export default function useShopAppData(shopNumber?: string) {
  const popups = useSelector((state: any) => state.display.popups);

  const shop = useSelector((state: any) =>
    getShopByNumber(state, { shop_number: shopNumber }),
  );
  const order = useSelector((state: any) =>
    getShortOrderByNumber(state, {
      form_number: shopNumber,
      order_type: "SHOP",
    }),
  );

  const shopShippingAddresses = useSelector((state: any) => {
    if (!shop?.shop_id) return [];
    return getAddressDropdown(state, { parent_id: shop.shop_id }).filter(
      (a: any) => a.parent_type === "SHOP" && a.address_type === "SHIPPING",
    );
  });

  const avalaraShop = useMemo(
    () => isAvalaraShop(shop, shopShippingAddresses),
    [shop, shopShippingAddresses],
  );

  return {
    popups,
    shop,
    order,
    isAvalaraShop: avalaraShop,
  };
}
